import type { LawFirmCase, PagedList } from '~/models'
import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'

export const Get = params => $apiGet<PagedList<LawFirmCase>>(`/v1/lawFirmCase`, params)

export const GetBySysNumberKeyword = (params: { sysNumberKeyword: string, clientName?: string, lawyerName?: string }, isLoading?) => $apiGet<LawFirmCase[]>(`/v1/lawFirmCase/bySysNumberKeyword`, params, isLoading)

export const GetByEncryptionId = encryptionId => $apiGet<LawFirmCase>(`/v1/lawFirmCase/${encryptionId}`)

export const Put = (encryptionId, body) => $apiPut<void>(`/v1/lawFirmCase/${encryptionId}`, body)

export const Post = body => $apiPost<void>(`/v1/lawFirmCase`, body)

export const Remove = encryptionId => $apiPut<void>(`/v1/lawFirmCase/remove/${encryptionId}`)
